import type { PromoCampaignModel, PromoProductModel } from '@/shared/generated'
import type { UseQueryOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const usePromoCampaignsQuery = (
	options?: UseQueryOptions<PromoCampaignModel[], Error>
) =>
	useQuery<PromoCampaignModel[], Error>({
		queryKey: ['promo-campaigns'],
		queryFn: () => client.promoCampaigns.listPromoCampaigns(),
		...(options || {}),
	})

export const usePromoProductsQuery = <T = PromoProductModel[]>(
	promoCampaignId: string
) =>
	useQuery<PromoProductModel[], AxiosError, T>({
		queryKey: ['promo-products', promoCampaignId],
		queryFn: () =>
			client.promoCampaigns.listPromoCampaignProducts({ promoCampaignId }),
	})
